import { CustomFont } from 'data/User';
import { makeFontNameCustom } from 'utils';

export const loadCustomFont = (font: CustomFont): Promise<void> => {
  return new Promise((resolve: Function, reject: Function) => {
    var myFont = new FontFace(
      makeFontNameCustom(font.name),
      `url(${font.url})`
    );
    myFont
      .load()
      .then(() => {
        (document.fonts as any).add(myFont);
        resolve();
      })
      .catch(e => {
        reject(e);
      });
  });
};



// WEBPACK FOOTER //
// ./src/utils/FontUtils.ts